<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'app',
        mounted() {
           
        },
	}
</script>

<style>
 @import "./styles/common/global.scss";
body {
	margin: 0px;
	padding: 0px;
	font-family: "Helvetica Neue",Helvetica,Arial,"PingFang SC",sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?42d1e11c